import { CLOSE_MODAL, OPEN_MODAL } from './constants';

export const openModal = (modalName, modalParameters) => (
  { type: OPEN_MODAL, data: { modalName, modalParameters } }
);

export const closeModal = () => ({ type: CLOSE_MODAL });
